module.exports = __webpack_public_path__ + "static/media/3154.99272166.jpg";